module.exports = __webpack_public_path__ + "static/media/IE.1229c946.png";